import { config_settings } from '@/config.js';
import Vue from 'vue';

export const getSections = () => {
  return Vue.$http.get(config_settings.RESOURCE_SERVER_URL + '/GET/sections');
};

export const getSubSection = (codSubSec) => {
  return Vue.$http.get(config_settings.RESOURCE_SERVER_URL + '/GET/sub_sections/'+codSubSec);
};
